import { Outlet, Link, useOutletContext } from 'react-router-dom';
import React, {useState} from 'react';

async function sendUserRequest(friendCode) {
    const response = await fetch('/api/send-friend-request', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friendCode: friendCode,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

function AccountFriendsMainLayout() {
    const {userPendingFriends, userCurrentFriends, userFriendCode} = useOutletContext();
    const countPendingFriends = userPendingFriends?.length || 0;
    const countCurrentFriends = userCurrentFriends?.length || 0;

    const [value, setValue] = useState("");
    const [activeSection, setActiveSection] = useState('Pending Requests');

    const handleChange = (e) => {
        const result = e.target.value.replace(/\D/g, "");
        setValue(result);
    };

    const setButtonActive = (sectionLabel) => {
        setActiveSection(sectionLabel);
    };

    const handleSendRequest = (code) => () => {
        sendUserRequest(code);
        setValue("")
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(userFriendCode);
        } catch (err) {
            console.error("Errore nella copia:", err);
        }
    };

    const menuItems = [
        { key: "1", label: 'Pending Requests', link : "/friends/pending-requests", number: `${countPendingFriends}`},
        /*{ key: "2", label: 'Sent Requests', link : "/friends/sent-requests"},*/
        { key: "3", label: 'Current Friends', link : "/friends/current-friends", number: `${countCurrentFriends}`}
    ];

    return (
        <main className="flex flex-1 justify-center py-8">
            <div className="layout-content-container flex flex-col w-full max-w-[960px] px-4 md:px-10">

                <div className="flex flex-wrap justify-between items-end gap-3 mb-6">
                    <div className="flex flex-col gap-1">
                        <h1 className="text-slate-900 dark:text-white text-4xl font-black leading-tight tracking-tight font-display uppercase">Friends &amp; Requests</h1>
                        <p className="text-slate-500 dark:text-[#92adc9] text-base font-normal">Manage your racing network and driver connections.</p>
                    </div>
                </div>

                <div className="mb-4">
                    <div className="inline-flex items-center gap-4 p-3 bg-surface-dark border border-border-dark rounded-lg">
                        <div className="flex flex-col px-1">
                            <span className="text-[10px] font-bold text-slate-500 dark:text-[#92adc9] uppercase tracking-[0.2em] mb-0.5">Your Friend Code</span>
                            <div className="flex items-center gap-3">
                                <span className="text-lg font-bold text-white tracking-widest font-mono">{userFriendCode}</span>
                                <button onClick={handleCopy} className="group flex items-center justify-center p-1.5 rounded bg-border-dark hover:bg-primary/20 transition-all" title="Copy code">
                                    <span className="material-symbols-outlined text-sm text-slate-400 group-hover:text-primary transition-colors">content_copy</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-8">
                    <label className="flex flex-col w-full group">
                        <div className="flex w-full items-stretch rounded-lg h-14 bg-slate-100 dark:bg-surface-dark border border-slate-200 dark:border-border-dark focus-within:border-primary transition-all">
                            <div className="text-slate-400 dark:text-[#92adc9] flex items-center justify-center px-4">
                                <span className="material-symbols-outlined">person_add</span>
                            </div>
                            <input className="w-full flex-1 bg-transparent border-none text-slate-900 dark:text-white focus:ring-0 placeholder:text-slate-400 dark:placeholder:text-[#92adc9] text-base font-normal px-2 outline-none" placeholder="Enter Driver ID..." type="text" value={value} onChange={handleChange} />
                            <div className="p-2">
                                <button onClick={handleSendRequest(value)} className="h-full px-6 bg-primary text-white font-bold rounded-lg hover:bg-primary/90 transition-all uppercase tracking-wider text-xs">
                                    Send Request
                                </button>
                            </div>
                        </div>
                    </label>
                </div>

                <div className="mb-6">
                    <div className="flex border-b border-slate-200 dark:border-[#324d67] gap-8">
                        {menuItems.map((item) => (
                            <Link 
                                to={item.link} 
                                key={item.key}
                                onClick={() => setButtonActive(item.label)}
                                    className={`flex flex-col items-center justify-center border-b-[3px] ${
                                        activeSection === item.label
                                            ? "border-primary text-slate-900 dark:text-white pb-[13px] pt-4"
                                            : "border-transparent text-slate-500 dark:text-[#92adc9] pb-[13px] pt-4 hover:text-primary transition-colors"
                                    }`}>
                                        
                                    <div className="flex items-center gap-2">
                                        <p className="text-sm font-bold leading-normal tracking-wider uppercase">{item.label}</p>
                                        <span className="bg-primary/20 text-primary text-[10px] px-1.5 py-0.5 rounded font-bold">{item.number}</span>
                                    </div>
                            </Link>
                        ))}
                    </div>
                </div>

                <Outlet context={{userPendingFriends, userCurrentFriends}}/>
            </div>
        </main>
    );
}

export default AccountFriendsMainLayout;